import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import NextLink from "next/link";
import React, { forwardRef, Fragment } from "react";
export var Link = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var _href = _param.href, href = _href === void 0 ? "" : _href, onClick = _param.onClick, underline = _param.underline, children = _param.children, className = _param.className, iconBefore = _param.iconBefore, props = _object_without_properties(_param, [
        "href",
        "onClick",
        "underline",
        "children",
        "className",
        "iconBefore"
    ]);
    var isExternal = href && !href.startsWith("/") && !href.startsWith("#");
    var Wrapper = !isExternal ? NextLink : Fragment;
    if (isExternal && !props.target) {
        props.target = "_blank";
    }
    return /*#__PURE__*/ _jsx(Wrapper, _object_spread_props(_object_spread({}, isExternal ? {} : {
        passHref: true,
        legacyBehavior: true,
        href: href
    }), {
        children: /*#__PURE__*/ _jsxs("a", _object_spread_props(_object_spread({
            ref: ref,
            href: href || "",
            className: clsx("appearance-none max-w-max relative", "font-medium !border-white/0 cursor-pointer", iconBefore && "whitespace-nowrap", underline ? "underline" : "no-underline border-b-[2px] hover:!border-[color:currentColor] active:!border-[color:currentColor]", className),
            onClick: onClick && function(e) {
                if (!href) {
                    // otherwise it will trigger the link
                    e.preventDefault();
                }
                onClick && onClick(e);
            },
            style: {
                transition: "all 0.1s ease 0s"
            }
        }, props), {
            children: [
                iconBefore && /*#__PURE__*/ _jsx("div", {
                    className: "inline [&>*]:inline mr-1",
                    children: iconBefore
                }),
                children
            ]
        }))
    }));
});
Link.displayName = "Link";
